import { render, staticRenderFns } from "./AdminOutput.vue?vue&type=template&id=bef14d0a&scoped=true"
import script from "./AdminOutput.vue?vue&type=script&lang=js"
export * from "./AdminOutput.vue?vue&type=script&lang=js"
import style0 from "./AdminOutput.vue?vue&type=style&index=0&id=bef14d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef14d0a",
  null
  
)

export default component.exports